import { useContext, useEffect, useRef } from 'react';
import { NotificationsStoreContext } from '../../common/ui/notifications-context';
import { triggerNotificationsAPICallFailed, triggerNotificationsAPICallSucceeded, useCreateFireAnalyticsFromTrigger } from '../../common/utils/analytics';
import { markSeenApiRoute, markSeenNotificationsFetch } from '../../common/utils/mark-seen-client';
export var useMarkSeenService = function useMarkSeenService(_ref) {
  var firstRequestCompleted = _ref.firstRequestCompleted;
  var unseenCalled = useRef(false);
  var fireNotificationsAPICallSucceeded = useCreateFireAnalyticsFromTrigger(triggerNotificationsAPICallSucceeded);
  var fireNotificationsAPICallFailed = useCreateFireAnalyticsFromTrigger(triggerNotificationsAPICallFailed);
  var _useContext = useContext(NotificationsStoreContext),
    packageName = _useContext.packageName,
    packageVersion = _useContext.packageVersion;
  useEffect(function () {
    if (firstRequestCompleted && !unseenCalled.current) {
      markSeenNotificationsFetch({
        packageName: packageName,
        packageVersion: packageVersion
      }).then(function (_) {
        return fireNotificationsAPICallSucceeded(markSeenApiRoute);
      }).catch(function (e) {
        return fireNotificationsAPICallFailed(markSeenApiRoute, e.code);
      });
      unseenCalled.current = true;
    }
  }, [unseenCalled, firstRequestCompleted, fireNotificationsAPICallSucceeded, fireNotificationsAPICallFailed, packageName, packageVersion]);
};